var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        lotteryItem: true,
        final: _vm.final,
    }},[_vm._v("\n    "+_vm._s(_vm.currentName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }